import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";

import { AppForm } from "../../forms/AppForm";
import { AppInput } from "../../forms/AppInput";
import { AppSelect } from "../../forms/AppSelect";
import { AppSubmit } from "../../forms/AppSubmit";
import { GET_CITY_BY_STATE } from "../../Graphql/queries/queryGetCityByState";
import { useToastError } from "../../Hooks/useToastError";

import { ContainerInput, ContainerInputs } from "./styles";
import useScreenSize from "../../Hooks/useScreenSize";

const DataForm = ({ handleSubmit, color, dataState, setLocation, validationSchema, rumv }) => {
  // eslint-disable-next-line
  const SITE_KEY = process.env.REACT_APP_SITE;
  const { width } = useScreenSize();
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);

  const [sendState, { error, data }] = useLazyQuery(GET_CITY_BY_STATE);

  useToastError(error);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, [SITE_KEY]);

  useEffect(() => {
    if (state !== null && city !== null) {
      setLocation({
        state: state,
        city: city,
      });
    }
    if (state !== null) {
      sendState({
        variables: {
          stateId: parseInt(state),
        },
      });
    }
  }, [state, city, sendState, setLocation]);

  const cities = data?.getCitiesByState.data;

  return (
    <AppForm
      initialValues={{
        name: "",
        lastName: "",
        phoneNumber: "",
        secondaryPhoneNumber: "",
        whatsAppPhoneNumber: "",
        state: "",
        city: "",
        neighborhood: "",
        email: "",
        rumv: "",
      }}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <ContainerInputs>
        <ContainerInput>
          <AppInput label="Nombre(*)" name="name" style={{ height: "28px" }} />
        </ContainerInput>
        <ContainerInput>
          <AppInput label="Apellidos(*)" name="lastName" style={{ height: "28px" }} />
        </ContainerInput>
        <ContainerInput>
          <AppInput label="Teléfono de contacto (1)*" name="phoneNumber" style={{ height: "28px" }} />
        </ContainerInput>
      </ContainerInputs>
      <ContainerInputs>
        <ContainerInput>
          <AppInput
            label="Teléfono de contacto de un amigo o familiar (2)*"
            name="secondaryPhoneNumber"
            style={{ height: "28px" }}
          />
        </ContainerInput>
        <ContainerInput>
          <AppInput
            label="WhatsApp (añadir indicativo si es internacional)"
            name="whatsAppPhoneNumber"
            style={{ height: "28px" }}
          />
        </ContainerInput>
        <ContainerInput>
          <AppSelect
            label="Departamento(*)"
            name="state"
            data={dataState}
            value={state}
            onChange={(e) => setState(e.target.value)}
            style={{ height: "28px" }}
            space={width <= 1024}
          />
        </ContainerInput>
      </ContainerInputs>
      <ContainerInputs>
        <ContainerInput>
          <AppSelect
            label="Municipio(*)"
            name="city"
            data={cities || []}
            value={city}
            onChange={(e) => setCity(e.target.value)}
            style={{ height: "28px" }}
          />
        </ContainerInput>
        <ContainerInput>
          <AppInput label="Barrio/Dirección(*)" name="neighborhood" style={{ height: "28px" }} />
        </ContainerInput>
        <ContainerInput>
          <AppInput label="Correo electrónico(*)" name="email" style={{ height: "28px" }} />
        </ContainerInput>
      </ContainerInputs>
      <ContainerInputs>
        <ContainerInput>{rumv && <AppInput label="# RUMV(*)" name="rumv" style={{ height: "28px" }} />}</ContainerInput>
        <ContainerInput></ContainerInput>
        <ContainerInput>
          <AppSubmit title="Guardar" style={{ backgroundColor: color, height: 28 }} form={true} />
        </ContainerInput>
      </ContainerInputs>
    </AppForm>
  );
};

DataForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  color: PropTypes.string,
  dataState: PropTypes.array,
  dataCity: PropTypes.array,
  setLocation: PropTypes.func,
  validationSchema: PropTypes.object,
  rumv: PropTypes.bool,
};

export default DataForm;
